






























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  EmployerMigrationPeriod
} from "@/admin/types";
import VueRouter, { Location } from "vue-router";
import moment from "moment";
import { Validator } from "vee-validate";
import { useEmployerStore } from "@/admin/store/employer";

const zone = "America/Chicago";

@Component
export default class EmployerMigrationPeriodForm extends Vue {
  $router: VueRouter;
  $validator: Validator;
  employerStore = useEmployerStore();

  isLoaded = false;
  isEditMode = true;
  moment = moment;
  today = moment().toDate();
  todayAsString = moment().format("YYYY-MM-DD");
  @Prop() employerId: string;

  employerMigrationPeriodFormModel: EmployerMigrationPeriod = {
    dateStart: this.today,
    dateEnd: this.today
  };
  employerMigrationPeriodIsSubmitting = false;

  created (): void {
    this.employerStore.getEmployerMigrationPeriod(Number(this.employerId));
  }

  get employerMigrationPeriodSubmitDisabled (): boolean {
    return this.$validator.errors.any() || this.employerMigrationPeriodIsSubmitting;
  }

  switchToEditMode (): void {
    this.isEditMode = true;
  }

  switchToViewMode (): void {
    this.isEditMode = false;
    this.resetEmployerMigrationPeriodForm();
  }

  get showUpdateButton () {
    return this.hasExistingMigration && this.isEditMode === false;
  }

  resetEmployerMigrationPeriodForm (): void {
    if (this.hasExistingMigration) {
      this.employerMigrationPeriodFormModel.dateStart = this.employerStore.savedEmployerMigrationPeriod.dateStart;
      this.employerMigrationPeriodFormModel.dateEnd = this.employerStore.savedEmployerMigrationPeriod.dateEnd;
    } else {
      this.employerMigrationPeriodFormModel.dateStart = this.today;
      this.employerMigrationPeriodFormModel.dateEnd = this.today;
    }
  }

  get hasExistingMigration (): boolean {
    return this.employerStore.savedEmployerMigrationPeriod &&
        this.employerStore.savedEmployerMigrationPeriod.dateStart !== null;
  }

  get disableForm (): boolean {
    return !this.isEditMode;
  }

  get migrationPeriodInDays (): number {
    const start = moment(this.employerMigrationPeriodFormModel.dateStart);
    const end = moment(this.employerMigrationPeriodFormModel.dateEnd);
    const diffInDays = moment.duration(end.diff(start)).asDays();
    if (diffInDays < 1) {
      return 0;
    }
    return Math.ceil(diffInDays);
  }

  submitEmployerMigrationPeriodForm (): void {
    if (this.employerMigrationPeriodIsSubmitting) {
      return;
    }

    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.employerMigrationPeriodIsSubmitting = true;
      this.employerStore.saveEmployerMigrationPeriod(
              { employerId: Number(this.employerId), request: this.employerMigrationPeriodFormModel })
          .finally(() => {
            this.employerMigrationPeriodIsSubmitting = false;
          });
    });
  }

  @Watch("employerStore.savedEmployerMigrationPeriod")
  setFormData (): void {
    if (this.hasExistingMigration && this.employerStore.savedEmployerMigrationPeriod.dateStart !== null) {
      this.isEditMode = false;
    }
    this.employerMigrationPeriodFormModel.dateStart = this.employerStore.savedEmployerMigrationPeriod.dateStart;
    this.employerMigrationPeriodFormModel.dateEnd = this.employerStore.savedEmployerMigrationPeriod.dateEnd;
  }
}
